import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import { useEffect } from 'react';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
class JoinStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }
  arr = [];

  @observable contact_email = '';
  @observable contact_email2 = '';
  @observable contact_title = '';
  @observable contact_title2 = '';
  @observable msg1 = '';
  @observable msg2 = '';
  @observable qrCode = '';

  classLists = ['a', 'b', 'c', 'd'];

  @observable mainStore;

  //前往购买

  use() {
    super.use();
    const layerData = useLayerData('part5');

    useEffect(
      () => {
        if (layerData) {
          this.arr = layerData.stepList;
          this.contact_email = layerData.contact_email;
          this.contact_email2 = layerData.contact_email2;
          this.contact_title = layerData.contact_title;
          this.contact_title2 = layerData.contact_title2;
          this.msg1 = layerData.msg1;
          this.msg2 = layerData.msg2;
          this.qrCode = String(layerData.qrCode);
        }
      },
      [layerData]
    );
    useMount(() => {});
  }
}

export default JoinStore;
